import { createAction, props } from '@ngrx/store';

export const SET_ORG_NAME = createAction(
  '[Org Context] Set Org Name',
  props<{ payload: {name: string} }>()
);
